import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const radioOnlyIconLabelFn = /* @__PURE__ */ createRecipe('radio-icon-label', {
  "size": "l"
}, [])

const radioOnlyIconLabelVariantMap = {
  "size": [
    "l",
    "m"
  ]
}

const radioOnlyIconLabelVariantKeys = Object.keys(radioOnlyIconLabelVariantMap)

export const radioOnlyIconLabel = /* @__PURE__ */ Object.assign(memo(radioOnlyIconLabelFn.recipeFn), {
  __recipe__: true,
  __name__: 'radioOnlyIconLabel',
  __getCompoundVariantCss__: radioOnlyIconLabelFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: radioOnlyIconLabelVariantKeys,
  variantMap: radioOnlyIconLabelVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, radioOnlyIconLabelVariantKeys)
  },
  getVariantProps: radioOnlyIconLabelFn.getVariantProps,
})